import type { DriveStep } from 'driver.js';

export const invoicesTourSteps: DriveStep[] = [
  {
    element: '[data-tour="invoice-add-btn"]',
    popover: {
      title: 'Neue Rechnung erstellen',
      description: 'Erstelle eine neue Rechnung mit automatischer ZUGFeRD-PDF-Generierung. Klient wählen, Positionen eingeben, fertig.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="invoice-filters"]',
    popover: {
      title: 'Filtern & Sortieren',
      description: 'Filtere nach Status (Entwurf, Gesendet, Bezahlt, Überfällig) und durchsuche deine Rechnungen.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="invoice-list"]',
    popover: {
      title: 'Rechnungsliste',
      description: 'Klicke auf eine Rechnung für Details, PDF-Download, E-Mail-Versand oder Mahnungen.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="invoice-dunning"]',
    popover: {
      title: 'Mahnwesen',
      description: 'Überfällige Rechnungen werden automatisch erkannt. 4 Mahnstufen mit E-Mail-Vorlagen stehen bereit.',
      side: 'bottom',
      align: 'end',
    },
  },
];
